import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useSaleCompStore } from '../..';
import useInsightsShape from '../../hooks/useInsightsShape';
import useSaleCompsInsideShape from '../../hooks/useSaleCompsInsideShape';
import useSaleCompsWithGlobalFilters from '../../hooks/useSaleCompsWithGlobalFilters';
import { IDetailsTabProps } from '../../interfaces/IDetailsTabProps';
import SaleCompsGrid from '../saleComps/SaleCompsGrid';

function InsightsSaleCompsTab({ visible, setEntityCount }: IDetailsTabProps) {
    const saleCompStore = useSaleCompStore();
    const insightsShape = useInsightsShape();
    const saleComps = useSaleCompsWithGlobalFilters(useSaleCompsInsideShape(saleCompStore.saleComps, insightsShape));

    useEffect(() => setEntityCount(saleComps.length), [saleComps]);

    if (!visible || !insightsShape)
        return null;

    return (
        <SaleCompsGrid saleComps={saleComps} />
    );
}

export default observer(InsightsSaleCompsTab);